import React, { useContext } from "react";
import { useTextDomainContext } from "@/app/providers";
import { getPartnerKey } from "@/utils";
import { Grid, Typography, Stack } from "@mui/material";
import { Link } from "react-router";

export const RegisterLinkSection = () => {
  const { TextDomainContext } = useTextDomainContext();
  const { gettext } = useContext(TextDomainContext);
  const partnerKey = getPartnerKey();

  return (
    <>
      <Grid size={{ xs: 12 }}>
        {partnerKey === "fabeke" && (
          <Stack
            direction="row"
            sx={{ alignItems: "baseline", justifyContent: "center" }}
          >
            <Typography>{gettext("Already have an account?")}</Typography>
            <Typography sx={{ fontSize: 16, fontWeight: 500 }}>
              &nbsp;
            </Typography>
            <Typography
              component={Link}
              to="/auth/login"
              sx={{
                textDecoration: "none",
                fontSize: 16,
                fontWeight: 500,
                color: "primary",
              }}
            >
              {gettext("Sign in")}.
            </Typography>
          </Stack>
        )}
        <Stack
          direction="row"
          sx={{ alignItems: "baseline", justifyContent: "center" }}
        >
          <Typography
            component={Link}
            to="/auth/forgot-password"
            sx={{
              textDecoration: "none",
              fontSize: 16,
              fontWeight: 500,
              color: "primary",
            }}
          >
            {gettext("Forgot Your Password?")}
          </Typography>
        </Stack>
      </Grid>
    </>
  );
};
